'use client'
import { useState, useEffect } from 'react'
import { notify } from '@/utils/notification'
import type { TagDataType } from '@/interfaces/pages'
import { getAllTags } from '@/lib/actions'
import { SubscribeForm } from '@/components/molecules/SubscribeForm'

import './styles.scss'

export const SubscribeSection = () => {
  const [segments, setSegments] = useState<TagDataType[]>([])
  useEffect(() => {
    const fetchTags = async () => {
      const response = await getAllTags({}, {})
      if ('error' in response) {
        notify(
          'Houve um erro ao buscar os segmentos. Tente novamente mais tarde.',
          'error',
        )
      } else {
        const segs: TagDataType[] = response.data.map((seg) => ({
          id: seg.id,
          title: seg.attributes.title,
          slug: seg.attributes.slug,
          image: seg.attributes.image?.data
            ? {
                url: seg.attributes.image.data.attributes.url,
                alternativeText:
                  seg.attributes.image.data.attributes.alternativeText,
              }
            : null,
        }))
        setSegments(segs)
      }
    }
    fetchTags()
  }, [])

  return (
    <section className="subscribe-section">
      <div className="subscribe-content">
        <h2 className="font-weight-up">Inscreva-se em nossa newsletter</h2>
        <SubscribeForm segments={segments} />
      </div>
    </section>
  )
}
